// ProgressSpinner.tsx
import React from 'react';
import { Flex, Spin } from 'antd';

const ProgressSpinner: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-full">
     <Flex align="center" gap="middle">
    <Spin size="small" />
    <Spin />
    <Spin size="large" />
  </Flex>
    </div>
  );
};

export default ProgressSpinner;
